// extracted by mini-css-extract-plugin
module.exports = {"video-section":"q_bk d-flex","video-section--header":"q_bl","video-section__frame":"q_bm ml-3"};